import { useCallback } from 'react';

import { useVideoStreamController_stopStream } from '@/services/hooks';

import type { StopStreamRequest, UseStopStreamResult } from './types';

export function useStopStream(): UseStopStreamResult {
    const mutation = useVideoStreamController_stopStream();

    const mutateAsync = useCallback(
        async (variables: StopStreamRequest) => {
            await mutation.mutateAsync(variables);
            return undefined;
        },
        [mutation.mutateAsync]
    );

    return {
        ...mutation,
        isLoading: mutation.isPending,
        mutateAsync,
        data: undefined,
    };
}
